import { Component, Inject, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements AfterViewInit {

  public headline: string = "no headline"
  public checkValue: string = null;
  public text: string = null;
  public length: number = null;
  public hasSecondButton: boolean;
  public secondButtonTitle: string;
  public secondButtonCallback: (arg0: MatDialogRef<ConfirmDialogComponent>, arg1: ConfirmDialogComponent) => void;

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: ConfirmDialogComponentData,
    private _dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {
    this.headline = _data.headline;
    this.checkValue = _data.checkValue;
    this.text = _data.text;
    if(this.checkValue) this.length = this.checkValue.length;
    if(_data.hasSecondButton) this.hasSecondButton = true;
    else this.hasSecondButton = false;
    this.secondButtonTitle = _data.secondButtonTitle;
    this.secondButtonCallback = _data.secondButtonCallback;
  }

  checkCode(code: string){
    if(code === this.checkValue) this.confirm();
  }

  confirm(){
    this._dialogRef.close(true);
  }

  ngAfterViewInit(): void {
    
  }

  secondButtonClick(){
    if(this.secondButtonCallback) this.secondButtonCallback(this._dialogRef, this);
  }

  reject(){
    this._dialogRef.close(false);
  }

}

export class ConfirmDialogComponentData {
  checkValue?: string;
  headline: string;
  text: string;
  hasSecondButton: boolean;
  secondButtonTitle?: string;
  secondButtonCallback?: (arg0: MatDialogRef<ConfirmDialogComponent>, arg1: ConfirmDialogComponent) => void;
}